import {
    AnyVariables,
    Client,
    DocumentInput,
    OperationContext,
    cacheExchange,
    fetchExchange
} from "urql";

export type AGGV2ClientOptions = {
    gatewayUrl?: string;
};
const GATEWAY_URL = "/gateway/api/graphql";
const DEFAULT_OPTIONS: AGGV2ClientOptions = {
    gatewayUrl: GATEWAY_URL
};

export class AGGClientV2 {
    private readonly client: Client;
    public constructor(
        private readonly params: AGGV2ClientOptions = DEFAULT_OPTIONS
    ) {
        this.client = new Client({
            url: this.params.gatewayUrl || GATEWAY_URL,
            exchanges: [cacheExchange, fetchExchange]
        });
    }

    public async query<
        Data = unknown,
        Variables extends AnyVariables = AnyVariables
    >(
        query: DocumentInput<Data, Variables>,
        variables: Variables,
        context?: Partial<OperationContext>
    ) {
        return this.client.query(query, variables, context).toPromise();
    }
}
